<template>
  <div class="">
    <SidePageColumn side="right">
      <div class="text-left">
        <template v-for="(menu_item, index) in sub_menu_items">
          <NavbarMenuItem
            v-if="can_access(menu_item)"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></NavbarMenuItem>
        </template>
      </div>
    </SidePageColumn>
    <CenterNavbar
      :crumps="attrs.crumps"
      :title="attrs.title"
      :width_class="page_info.center_width_class"
      :show_staff="!show_banner"
      :navbar_cols="(attrs.navbar_cols)? attrs.navbar_cols : 4 "
    ></CenterNavbar>
    <div class="inner-page-container">
      <div
        v-if="show_banner"
        class="text-center white d-flex flex-column justify-space-between align-center"
      >
        <div>
          <v-img
            width="400"
            height="400"
            contain
            src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606720133/botswana%20services/website%20assets/contact-us-messages_yxy0ha.jpg"
          >
          </v-img>
        </div>
        <p class="pa-10 text-h5 pb-0 pt-2 mb-15">
          Manage and View Messages From  The <br/>Contact  Us Forms Of Your Businesses
          <br />
          <br />
          <v-btn
            class="ma-1 mb-4"
            dense
            rounded
            outlined
            color="success"
            @click="go_to_messages_list"
          >
            <v-icon left class="mobile-display-none">mdi-eye</v-icon>
            View Messages
          </v-btn>
          <br /><br />
        </p>
      </div>
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-show-loader')"
        @on-hide-loader="$emit('on-hide-loader')"
        @set-page-attributes="on_set_page_attributes"
      ></router-view>
    </div>
  </div>
</template>

<script>
import CenterNavbar from "./../../../components/CenterNavbar";
import page_info from "./../../../lib/page_info";
import SidePageColumn from "./../../../components/SidePageColumn";
import NavbarMenuItem from "./../../../components/NavbarMenuItem";
import Utils from "./../../../lib/Utils";
export default {
  name: "OwnerContactUsMessages",
  components: {
    CenterNavbar,
    SidePageColumn,
    Utils,
    NavbarMenuItem,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => ({
    page_info: page_info,
    sub_menu_items: [
      {
        label: "List Of Messages",
        icon: "mdi-view-list",
        to: "/owner/contact_us_messages/list",
        roles: ["super role", "backofficcee","owner"],
      },
    ],
    attrs: Utils.get_default_page_attr(),
  }),
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    on_set_page_attributes(attrs) {
      this.attrs = attrs;
    },
    go_to_messages_list() {
      this.$router.push("/owner/contact_us_messages/list");
    }
  },
  computed: {
    show_banner() {
      if (this.$route.path == "/owner/contact_us_messages") {
        return true;
      }
      return false;
    },
  }
};
</script>